import { useState, useEffect } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useGetLeadOwner = ({leadID}) => {
    const [leadOwner, setLeadOwner] = useState(null)


    useEffect(() => {
        if (!leadID) return;
        const fetchData = async() => {
            try{
                const queryParams = new URLSearchParams({
                    lead_id: leadID
                })
                const result = await apiRequest(`${API_ENDPOINTS.AUTH.GET_LEAD_OWNER}?${queryParams.toString()}`, 'GET')
                if (result === true) {
                    setLeadOwner(true)
                } else {
                    setLeadOwner(false)
                }
            } catch (error) {
                console.error(error)
            }
        }
        fetchData()
    }, [leadID])
    
    return leadOwner
}
